import axios from 'axios'
import router from '@/router';
import api from '@/api';

export const categoriesModule = {
    namespaced: true,

    state:() => ({
        isLoading: true,
        points_of_sale: null,
    }),

    mutations: {
    },

    actions: {
        async getPointOfSale({}) {
            return axios
            .get(api + "projects/tcode/shops/", {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                for(let i = 0; i < response.data.length; i++) {
                    response.data[i].label = response.data[i].name
                    response.data[i].value = response.data[i].code
                }

                return response.data
            })
            .catch((error) => {
                console.log(error);
            });
        },
        
        async fetchCategories({}, customQuery) {
            const shop = router.currentRoute.value.query.shop || router.currentRoute.value.params.shop;
            const project = router.currentRoute.value.query.project || router.currentRoute.value.params.project;
            const queryString = router.currentRoute.value.fullPath.split('?')[1];
            const queryPart = queryString ? queryString : '';
            console.log(shop,project)

            if(!shop || !project) return

            return axios
                .get(`${api}projects/${project}/shops/${shop}/categories/?${queryPart ? queryPart : customQuery}`, {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                .then((response) => {
                    return response.data.results;
                })
                .catch((error) => {
                    console.log(error);
                });
        },


        async fetchCurrentCategory({}, data) {
            
            return axios
            .get(`${api}projects/${data.project}/shops/${data.shop}/categories/${data.id}?all=true`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                console.log(error);
            });
        },

        fastEditCategory({}, data) {
            const shop = router.currentRoute.value.query.shop
            const project = router.currentRoute.value.query.project

            axios
            .patch(`${api}projects/${project}/shops/${shop}/categories/${data.id}/?all=true`,
                {
                    is_active: data.is_active,
                    is_popular: data.is_popular,
                    not_on_stop_list: data.not_on_stop_list,
                    is_available_for_agregators: data.is_available_for_agregators,
                    have_chopsticks: data.have_chopsticks
                },
                {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                console.log(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
        },

        async editCategory({}, data) {
            const shop = router.currentRoute.value.query.shop || router.currentRoute.value.params.shop
            const project = router.currentRoute.value.query.project || router.currentRoute.value.params.project

            return axios
            .patch(`${api}projects/${project}/shops/${shop}/categories/${data.id}/?all=true`,
                data.formData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                return response
            })
            .catch((error) => {
                console.log(error);
            });
        },

        async categoriesActions({}, data) {
            const shop = router.currentRoute.value.query.shop || router.currentRoute.value.params.shop
            const project = router.currentRoute.value.query.project || router.currentRoute.value.params.project
            return axios
            .get(`${api}projects/${project}/shops/${shop}/update/?action=${data.action}`)
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                console.log(error);
            });
        }
    }
}